import { Link } from "react-router-dom";
import { Globe, Mail, MapPin, Phone } from "lucide-react";
import { Wordmark } from "./Logo";
import { SITE } from "../lib/site";

const NAV = [
    { to: "/", label: "Home" },
    { to: "/about", label: "About Us" },
    { to: "/services", label: "Our Services" },
    { to: "/trailer-availability", label: "Trailer Availability" },
    { to: "/why-choose-us", label: "Why Choose Us" },
    { to: "/contact", label: "Contact Us" },
];

export default function Footer() {
    const siteUrl = window.location.origin;
    return (
        <footer className="bg-navy text-paper" data-testid="site-footer">
            <div className="container-x grid gap-12 py-16 lg:grid-cols-12 lg:py-20">
                <div className="lg:col-span-5">
                    <Wordmark light markClass="h-12 w-12" />
                    <p className="mt-6 max-w-sm text-sm leading-relaxed text-paper/70">
                        {SITE.role} — 40ft, 50ft & 60ft trailers for ODC, loose cargo and
                        long-distance transportation across India.
                    </p>
                    <p className="mt-4 font-hindi text-base text-paper/80">
                        One stop for all of India.
                    </p>
                </div>

                <div className="lg:col-span-3">
                    <p className="text-xs font-semibold uppercase tracking-[0.28em] text-brand">
                        Quick Links
                    </p>
                    <ul className="mt-5 space-y-3">
                        {NAV.map((n) => (
                            <li key={n.to}>
                                <Link
                                    to={n.to}
                                    data-testid={`footer-link-${n.label.toLowerCase().replace(/ /g, "-")}`}
                                    className="text-sm text-paper/70 transition-colors hover:text-paper"
                                >
                                    {n.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="lg:col-span-4">
                    <p className="text-xs font-semibold uppercase tracking-[0.28em] text-brand">
                        Contact
                    </p>
                    <ul className="mt-5 space-y-4 text-sm">
                        {SITE.phones.map((p, i) => (
                            <li key={p.tel}>
                                <a
                                    href={`tel:${p.tel}`}
                                    data-testid={`footer-phone-link-${i + 1}`}
                                    className="inline-flex items-center gap-3 text-paper/80 transition-colors hover:text-paper"
                                >
                                    <Phone className="h-4 w-4 shrink-0 text-brand" />
                                    +91 {p.display}
                                </a>
                            </li>
                        ))}
                        <li>
                            <a
                                href={`mailto:${SITE.email}`}
                                data-testid="footer-email-link"
                                className="inline-flex items-center gap-3 text-paper/80 transition-colors hover:text-paper"
                            >
                                <Mail className="h-4 w-4 shrink-0 text-brand" />
                                {SITE.email}
                            </a>
                        </li>
                        <li>
                            <a
                                href={siteUrl}
                                data-testid="footer-website-link"
                                className="inline-flex items-center gap-3 text-paper/80 transition-colors hover:text-paper"
                            >
                                <Globe className="h-4 w-4 shrink-0 text-brand" />
                                {SITE.website}
                            </a>
                        </li>
                        <li className="flex items-start gap-3 text-paper/80">
                            <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand" />
                            <span>{SITE.address}</span>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="border-t border-paper/10">
                <div className="container-x flex flex-col items-center justify-between gap-2 py-6 text-xs text-paper/50 sm:flex-row">
                    <span>© {new Date().getFullYear()} {SITE.name} — {SITE.tagline}</span>
                    <span>Established {SITE.established} • Kalamboli, Navi Mumbai</span>
                </div>
            </div>
        </footer>
    );
}
